export const clearUser = (state) => {
  state.user.id = "";
    state.user.userName = "";
    state.user.title = "";
    state.user.mail = "";
    state.user.companyName = "";
    state.user.profileUrl = null;
    state.user.token = "";
    state.user.defaultVisitorCardGroup = "";
    state.authMap.canliIzleme = 1;
    state.authMap.kisiler = 1;
    state.authMap.gecisYetkileri = 1;
    state.authMap.raporlar = 1;
    state.authMap.ayarlar = 1;
    state.authMap.tanimlamalar = 1;
    state.authMap.ziyaretciTakip = 1;
    state.authMap.yemekhane = 1;
    state.authMap.dashboard = 1;
    state.authMap.creditSale = 1;
    state.authMap.payrollManagement = 1;
    state.authMap.shiftManagement = 1;
    state.authMap.bekciTur = 1;
}

export const setUser = (state, data) =>{
    state.user.id = data.id;
    state.user.userName = data.userName;
    state.user.title = data.title;
    state.user.mail = data.mail;
    state.user.companyName = data.companyName;
    state.user.profileUrl = data.profileUrl;
    state.user.token = data.token;
    state.user.defaultVisitorCardGroup = data.defaultVisitorCardGroup;
    state.user.language = data.language;
    state.user.authType = data.authType;
    state.defaultFilters = data.defaultFilters;
}

export const setAuthority = (state, data) =>{
    state.authMap.canliIzleme = data.canliIzleme;
    state.authMap.kisiler = data.kisiler;
    state.authMap.gecisYetkileri = data.gecisYetkileri;
    state.authMap.raporlar = data.raporlar;
    state.authMap.ayarlar = data.ayarlar;
    state.authMap.tanimlamalar = data.tanimlamalar;
    state.authMap.ziyaretciTakip = data.ziyaretciTakip;
    state.authMap.yemekhane = data.yemekhane;
    state.authMap.dashboard = data.dashboard;
    state.authMap.creditSale = data.creditSale;
    state.authMap.puantajYonetimi = data.puantajYonetimi;
    state.authMap.shiftYonetimi = data.shiftYonetimi;
    state.authMap.shiftYetkileri = data.shiftYetkileri;
    state.authMap.bekciTur = data.bekciTur;
}

export const setCompanyName = (state, data) =>{
  state.user.companyName = data.companyName;
}

export const setMyUser = (state, data) =>{
  state.user.userName = data.userName;
  state.user.title = data.title;
  state.user.mail = data.mail;
  state.user.profileUrl = data.profileUrl;
  state.user.defaultVisitorCardGroup = data.defaultVisitorCardGroup;
}

export const setDefaultFilters = (state, data) =>{
  state.defaultFilters = data;
}

export const setRequiredFields = (state, data) =>{
  state.requiredFields = data;
}

export const setConfig = (state, data) =>{
  state.baseURL = data.baseURL;
  state.companyUrl = data.companyUrl;
  state.companyName = data.companyName;
  state.modules = data.modules;
}



// WEBPACK FOOTER //
// ./src/store/mutations.js